import { type FC } from "react";

import { useTimeRange } from "../../lens-insights/hooks";
import { MetricChange } from "../../shared/components/MetricChange";

import { DiffSection } from "./DiffSection";

interface LensDiffProps {
    diffValue?: string;
    isColumn?: boolean;
}

export const LensDiff: FC<LensDiffProps> = ({ diffValue = "", isColumn = false }) => {
    const { selectedPreviousTimeRangeLabel } = useTimeRange();
    const isDiffDefault = diffValue === "-";

    if (!diffValue || isDiffDefault || !selectedPreviousTimeRangeLabel) {
        return null;
    }

    return (
        <MetricChange
            layout={isColumn ? "column" : "row"}
            badge={<DiffSection diffValue={diffValue} />}
            text={`vs. ${selectedPreviousTimeRangeLabel}`}
        />
    );
};
